var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4 20v-2.52L17.18 4.288a1.2 1.2 0 0 1 .34-.212q.184-.075.387-.076t.39.064a.9.9 0 0 1 .35.228l1.067 1.074q.165.16.226.35.06.19.06.38 0 .204-.068.39a1 1 0 0 1-.218.339L6.519 20zM17.504 7.589 19 6.111 17.889 5l-1.477 1.496z"
})));
export { SvgEditBlack as ReactComponent };
export default __webpack_public_path__ + "6b7018e50cef8a11398f02a5c1b058f8.svg";